"use strict";

exports.__esModule = true;
exports.AggregateMeasureTableWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _ChartCard = require("../common/ChartCard");
var _reactIntl = require("react-intl");
var _AdvancedDataTable = require("../AdvancedDataTable");
var _AggregateMeasureTableElement = require("./AggregateMeasureTableElement");
var _AggregateMeasureTableFields = require("./AggregateMeasureTableFields");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AggregateMeasureTableWidget = exports.AggregateMeasureTableWidget = {
  name: "AggregateMeasureTableWidget",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "AggregateMeasureTableWidget.label",
    defaultMessage: "Aggregate Measure Table"
  }),
  icon: "th-list",
  group: _widgetGroups.TIMELINE_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "AggregateMeasureTableWidget",
      props: Object.assign({
        dataSource: "",
        dataRange: "",
        width: 512,
        height: 512
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: true,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: [],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 320,
      min: 32,
      max: 1024
    },
    height: {
      "default": 320,
      min: 32,
      max: 768
    }
  },
  components: {
    Element: (0, _ChartCard.withChartCard)(_AggregateMeasureTableElement.AggregateMeasureTableElement),
    Fields: _AggregateMeasureTableFields.AggregateMeasureTableFields,
    Thumbnail: _AdvancedDataTable.AdvancedDataTableThumbnail
  }
};